import React from 'react';

export default props => (
  <svg {...props}>
    {props.children}
    <path d="M10.25 1V6.18936L8.53036 4.46967L7.46969 5.53032L10.4696 8.53032C10.6103 8.67098 10.801 8.75 10.9999 8.75C11.1989 8.75 11.3896 8.67098 11.5303 8.53033L14.5303 5.53032L13.4696 4.46966L11.75 6.18928V1H10.25Z" />
    <path d="M11.5303 13.4697L14.5303 16.4697L13.4696 17.5303L11.7519 15.8127L11.75 21.0002L10.25 20.9997L10.252 15.8087L8.53027 17.5303L7.46961 16.4697L10.4696 13.4697C10.6103 13.329 10.801 13.25 10.9999 13.25C11.1989 13.25 11.3896 13.329 11.5303 13.4697Z" />
    <path d="M1 11.75H21V10.25H1V11.75Z" />
  </svg>
);
